export const APP_VERSION = '21922c5-1786695499816';
